import axios from "axios";
import Cookies from "js-cookie";
import config from "../../config";

const baseUrl = config.baseUrl;
const orgEndpoint = "/api/getEdah";

// Instancia axios con token
const api = axios.create({
    baseURL: baseUrl,
});

// Interceptor para agregar token
api.interceptors.request.use(
    (config) => {
        const token = Cookies.get("token");
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Obtener encuestas EDAH
const getEdah = async () => {
    try {
        const response = await api.get(orgEndpoint);
        return {
            status: response.status,
            data: response.data.encuestas_edah,
        };
    } catch (error) {
        console.error("Error fetching encuestas EDAH:", error);
        return {
            status: error.response ? error.response.status : 500,
            message: "Error fetching encuestas edah",
        };
    }
};

// Eliminar encuesta EDAH
const deleteEdah = async (oid, userLogin) => {
    try {
        const response = await api.delete(`/api/deleteEdah/${oid}`, {
            data: { userLogin }, // Se envía usuario que elimina
        });
        return response.data;
    } catch (error) {
        console.error("Error al eliminar EDAH:", error);
        throw error;
    }
};

export { getEdah, deleteEdah };
